import { useState } from 'react';

import { formatAmountDisplay, parseAmount, sanitizeAmount } from '@/utils/form';

/**
 * A money field over a form value that is a number: shows it grouped with commas, and hands
 * back the number to store.
 *
 * The number alone cannot be shown while it is typed: "12." and "12.50" are 12 and 12.5 to the
 * form, so the dot and the trailing zero would vanish under the cursor. The text as typed is kept
 * instead, but only while it still reads as the form's value, so a reset to another record's
 * number shows that number.
 */
export const useAmountDraft = () => {
  const [draft, setDraft] = useState('');

  const display = (value: number | string | null | undefined): string => {
    const stored = value === '' || value == null ? null : parseAmount(value);
    const typed = draft === '' ? null : parseAmount(draft);
    return formatAmountDisplay(typed === stored ? draft : stored === null ? '' : String(stored));
  };

  const change = (raw: string): number | null => {
    const next = sanitizeAmount(raw);
    setDraft(next);
    return next === '' ? null : parseAmount(next);
  };

  return { display, change };
};
